/**
 * Accountant Analysis Tools — robustness tooling for the defensible number.
 *
 * Two on-demand panels over the deterministic engines:
 *   1. Monte Carlo — the confidence interval around the claim ("how robust is
 *      this number?"; Daubert-relevant). Reuses the D3 MonteCarloDistribution chart.
 *   2. Sensitivity — how the claim moves as one driver (payroll / revenue /
 *      variable expenses) varies ±20% ("where is the number fragile?").
 *
 * In-house only (the endpoints are Clerk/org-scoped). This is a dedicated surface
 * by design: the Methodology Comparison view is for *comparing* methods (a read
 * mode); stress-testing a number is a *compute* mode with its own inputs.
 *
 * The body lives in AnalysisToolsContent so it can also render bare (no page
 * header) inside the accountant Case Workspace Defense stage (extract-content
 * pattern). This page is the standalone route wrapper — header shown.
 */

import React from 'react';
import AnalysisToolsContent from '../components/accountant/review/AnalysisToolsContent';

export default function AccountantAnalysisTools() {
  return <AnalysisToolsContent showHeader />;
}
